.rows {
	display: flex;
	flex-direction: column;
	gap: var(--space-5);
}

.viewAll {
	align-self: center;
	margin-top: var(--space-2);
	padding: var(--space-3) var(--space-5);
	border-radius: 999px;
	border: 1px solid var(--border);
	background: var(--surface-card);
	color: var(--ink);
	font-weight: 600;
}

.viewAll:hover {
	text-decoration: none;
	border-color: color-mix(in srgb, var(--accent-sage) 50%, transparent);
}
